import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import ButtonToggle from '../../core/components/ButtonToggle'
import IconCateg from '../../core/components/IconCateg'
import TagBar from '../../core/components/TagBar'
import TypeaheadGridInput, {matcher} from '../../core/components/TypeaheadGridInput'
import {CREATE_UPDATE_CATEGORY_ACTION_UPDATED, sendCreateUpdateCategoryAction, resetCreateUpdateCategoryAction, sendMoveParentCategoryAction, loadOpeningTicketPurposeRef} from '../actions'
import {OPENING_TICKET_PURPOSE_REF_ICONS, OpeningTicketPurposeRef, CreateUpdateCategoryAction} from '../models'
import i18n from '../i18n'
import style from './CreateUpdateCategoryModal.less'

function resultName(action) {
    switch (action) {
        case 'CreateCategory': return 'CategoryCreated'
        case 'UpdateCategory': return 'CategoryUpdated'
    }
}

function childrenCategoryFilter(parentCategory) {
    return (category) => {
        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid)
    }
}

function categoryMatcher(categories) {
    return matcher({
        source: categories,
        identify: (c) => c.label
    })
}

function iconMatcher(icons) {
    return matcher({
        source: icons,
        identify: (i) => i
    })
}

function categoryUpdate(category) {
    return {
        uid: category && category.uid,
        label: category && category.label,
        iconId: category && category.iconId,
        parentUid: category && category.parent && {uid: category.parent.uid}
    }
}

function actionReset(category) {
    return {
        label: category && category.label,
        iconId: category && category.iconId,
        parentUid: category && category.parent && {uid: category.parent.uid},
        action: 'CreateCategory'
    }
}

class CreateUpdateCategoryModal extends Component {
    static propTypes = {
        category: PropTypes.object,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            childrenCategorySource: () => null,
            siblingCategorySource: () => null,
            iconSource: () => null
        }
    }

    componentWillMount() {
        const {dispatch, category} = this.props

        const reset = actionReset(category)
        dispatch(resetCreateUpdateCategoryAction(reset))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.category != this.props.category) {
            const {dispatch, category} = nextProps

            const reset = actionReset(category)
            dispatch(resetCreateUpdateCategoryAction(reset))
        }

        if (nextProps.reference != this.props.reference
            || nextProps.action != this.props.action) {
            const {action, reference} = nextProps

            const childrenCategorySource = categoryMatcher(reference.categories.filter(childrenCategoryFilter(action)))
            const siblingCategorySource = categoryMatcher(reference.categories.filter(childrenCategoryFilter(action && action.parentUid)))
            const iconSource = iconMatcher(!(action && action.iconId) && OPENING_TICKET_PURPOSE_REF_ICONS || [])
            this.setState({childrenCategorySource, siblingCategorySource, iconSource})
        }
    }

    _sendAction() {
        const {dispatch, action, reference, onHide} = this.props

        const actionName = action.action
        const actionUid = action.uid
        const actionParent = action.parentUid
        const category = reference.categories.find((c) => c.uid == action.uid)

        var categoryId
        return dispatch(sendCreateUpdateCategoryAction()).then((action) => {
            categoryId = action.categoryUid
            return category && (category.parent && category.parent.uid) != (actionParent && actionParent.uid) && dispatch(sendMoveParentCategoryAction(actionParent && actionParent.uid, actionUid))
        }).then(() => {
            return dispatch(loadOpeningTicketPurposeRef())
        }).then((action) => {
            const category = action.ref.categories.find((c) => c.uid == categoryId)
            onHide(null, resultName(actionName), category)
        })
    }

    render() {
        const {dispatch, form, action, onHide, reference, ...others} = this.props
        const {childrenCategorySource, siblingCategorySource, iconSource} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const displayCategory = (category, active, path) => (
            <div className={style.category}>
                <IconCateg iconId={category.iconId} exponent={active && 'X'}/>
                <label>{category.label}</label>
                {path && (
                    <small>></small>
                )}
            </div>
        )

        const displayIcon = (iconId, active) => (
            <div className={style.icon}>
                <IconCateg iconId={iconId} exponent={active && 'X'}/>
                <label>{iconId.replace(/_/g, ' ').replace('1-', '')}</label>
            </div>
        )

        const categoryField = (field) => {
            function onChange(value) {
                const nextValue = categoryUpdate(value)
                field.onChange(nextValue)
            }

            return {...field, onChange}
        }

        const categoryPathField = (field) => {
            const value = OpeningTicketPurposeRef.expendParentCategories(reference, field.value && reference.categories.find((c) => c.uid == field.value.uid))

            const onChange = (categories) => {
                const nextValue = categoryUpdate(OpeningTicketPurposeRef.getLeafCategory(categories))
                field.onChange(nextValue)
            }

            return {...field, value, onChange}
        }

        const actionField = (field) => {
            function onChange(value) {
                if (value) {
                    field.onChange(value)
                }
            }

            return {...field, onChange}
        }

        const categoryTypeaheadHeader = (
            <ButtonToggle multi
                identify={(c) => c.uid}
                {...categoryPathField(form())}>
                <ul className={cx(style.typeaheadHeaderGroup, style.categoryGroup)}>
                    {OpeningTicketPurposeRef.expendParentCategories(reference, action && reference.categories.find((c) => c.uid == action.uid)).map((category) => (
                        <li key={category.uid}>
                            <Button
                                bsStyle='link'
                                value={category}>
                                {displayCategory(category, true, true)}
                            </Button>
                        </li>
                    ))}
                </ul>
            </ButtonToggle>
        )

        const iconTypeaheadHeader = action && action.iconId && (
            <ButtonToggle
                {...form.iconId()}>
                <ul className={cx(style.typeaheadHeaderGroup, style.iconGroup)}>
                    <li>
                        <Button
                            bsStyle='link'
                            value={action.iconId}>
                            {displayIcon(action.iconId, true)}
                        </Button>
                    </li>
                </ul>
            </ButtonToggle>
        )

        return (
            <Modal
                bsSize='large'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.manageCategories}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.defaultContent}>
                        <Row>
                            <Col sm={4}>
                                <div className={style.actionGroup}>
                                    <ButtonToggle
                                        {...actionField(form.action())}>
                                        <Button block
                                            value='CreateCategory'>
                                            {i18n.newCategory}
                                        </Button>
                                        <Button block
                                            value='UpdateCategory'>
                                            {i18n.updateCategory}
                                        </Button>
                                    </ButtonToggle>
                                </div>
                                <TypeaheadGridInput
                                    size='small'
                                    source={childrenCategorySource}
                                    identify={(c) => c.uid}
                                    display={displayCategory}
                                    header={categoryTypeaheadHeader}
                                    placeholder={i18n.searchCategory}
                                    disabled={action && action.action == 'CreateCategory'}
                                    {...categoryField(form())} />
                            </Col>
                            <Col sm={8}>
                                <Row>
                                    <Col xsHidden sm={3}>
                                        <h5>{i18n.parentCategory}</h5>
                                    </Col>
                                    <Col sm={9}>
                                        <TagBar multi
                                            display={(c) => displayCategory(c, true, true)}
                                            identify={(c) => c.uid}
                                            disabled={action && action.action == 'UpdateCategory' && !action.uid}
                                            label={action && action.parentUid && i18n.addChildCategory || i18n.addCategory}
                                            {...categoryPathField(form.parentUid())}>
                                            <TypeaheadGridInput
                                                source={siblingCategorySource}
                                                identify={(c) => c.uid}
                                                display={displayCategory}
                                                placeholder={i18n.searchCategory}
                                                {...form.parentUid()} />
                                        </TagBar>
                                    </Col>
                                </Row>
                                <form className='form-horizontal'>
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='label'
                                        label={requiredLabel(i18n.label)}
                                        disabled={action && action.action == 'UpdateCategory' && !action.uid}
                                        {...form.label()} />
                                    <TypeaheadGridInput
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        label={requiredLabel(i18n.icon)}
                                        source={iconSource}
                                        display={displayIcon}
                                        header={iconTypeaheadHeader}
                                        placeholder={i18n.searchIcon}
                                        disabled={(action && action.action == 'UpdateCategory' && !action.uid) || (action && !!action.iconId)}
                                        {...form.iconId()} />
                                </form>
                            </Col>
                        </Row>
                        <ButtonToolbar>
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !form.isValid()})}
                                onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.save}
                            </LoaderButton>
                            <Button
                                bsSize='large'
                                onClick={onHide}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

CreateUpdateCategoryModal = connectForm({
    target: 'action',
    schema: CreateUpdateCategoryAction.schema,
    action: CREATE_UPDATE_CATEGORY_ACTION_UPDATED
})(CreateUpdateCategoryModal)

CreateUpdateCategoryModal = connect((state) => ({
    reference: state.reference.openingTicketPurposeRef,
    action: state.reference.createUpdateCategoryAction
}))(CreateUpdateCategoryModal)

export default CreateUpdateCategoryModal


// WEBPACK FOOTER //
// ./lib/reference/components/CreateUpdateCategoryModal.js